import {
  getList,
  getInt32,
} from "@surya-digital/leo-ts-types";
import { OptionV1, OptionV1DTO } from "./optionV1";

export interface GridMultiChoiceQuestionV1DTO {
  options: OptionV1DTO[];
  maxSelectionAllowed: number;
}

export class GridMultiChoiceQuestionV1 {
  readonly isGridMultiChoiceQuestionV1GridMultiChoiceQuestionV1: boolean = true;

  readonly options: OptionV1[];
  readonly maxSelectionAllowed: number;

  static readonly constraints = {
    "options": {
      "minSize": 1,
      "maxSize": 32,
    },
    "maxSelectionAllowed": {
      "minValue": 1,
      "maxValue": 32,
    }
  }

  constructor(
  options: OptionV1[], 
  maxSelectionAllowed: number
  ) {
    GridMultiChoiceQuestionV1.validateOptions(options);
    this.options = options;
    GridMultiChoiceQuestionV1.validateMaxSelectionAllowed(maxSelectionAllowed);
    this.maxSelectionAllowed = maxSelectionAllowed;
  }

  static fromDTO(dto: GridMultiChoiceQuestionV1DTO): GridMultiChoiceQuestionV1 {
    const options = getList<OptionV1DTO, OptionV1>(
      dto,
      "options",
      OptionV1.fromDTO,
      InvalidGridMultiChoiceQuestionV1OptionsError
    );
    const maxSelectionAllowed = getInt32(dto, "maxSelectionAllowed", InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedError);
    return new GridMultiChoiceQuestionV1(
      options,
      maxSelectionAllowed
    );
  }

  toDTO(): GridMultiChoiceQuestionV1DTO {
    const dto: GridMultiChoiceQuestionV1DTO = {
        options: this.options.map((e: OptionV1) => { return e.toDTO() }),
        maxSelectionAllowed: this.maxSelectionAllowed
    };
    return dto;
  }
  private static validateOptions = (options: OptionV1[]): void => {
    if(options.length < 1) {
      throw new InvalidGridMultiChoiceQuestionV1OptionsMinSizeError(
        1,
        `Attribute options is too short. Size is ${options.length}. Min size is 1.`
      );
    }
    if(options.length > 32) {
      throw new InvalidGridMultiChoiceQuestionV1OptionsMaxSizeError(
        32,
        `Attribute options is too long. Size is ${options.length}. Max size is 32.`
      );
    }
  }
  private static validateMaxSelectionAllowed = (maxSelectionAllowed: number): void => {
    if(maxSelectionAllowed < 1) {
      throw new InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedMinValueError(
        1,
        `Attribute maxSelectionAllowed has value ${maxSelectionAllowed}. Min value is 1.`
      );
    }
    if(maxSelectionAllowed > 32) {
      throw new InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedMaxValueError(
        32,
        `Attribute maxSelectionAllowed has value ${maxSelectionAllowed}. Max value is 32.`
      );
    }
  }
  
}

GridMultiChoiceQuestionV1.prototype.toString = function toString(): string {
  return `GridMultiChoiceQuestionV1(options='${this.options}',maxSelectionAllowed='${this.maxSelectionAllowed}')`;
};

export class InvalidGridMultiChoiceQuestionV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiChoiceQuestionV1Error";
  }
}
export class InvalidGridMultiChoiceQuestionV1OptionsError extends InvalidGridMultiChoiceQuestionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiChoiceQuestionV1OptionsError";
  }
}

export class InvalidGridMultiChoiceQuestionV1OptionsMaxSizeError extends InvalidGridMultiChoiceQuestionV1OptionsError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiChoiceQuestionV1OptionsMaxSizeError";
  }
}

export class InvalidGridMultiChoiceQuestionV1OptionsMinSizeError extends InvalidGridMultiChoiceQuestionV1OptionsError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiChoiceQuestionV1OptionsMinSizeError";
  }
}

export class InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedError extends InvalidGridMultiChoiceQuestionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedError";
  }
}

export class InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedMaxValueError extends InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedMaxValueError";
  }
}

export class InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedMinValueError extends InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridMultiChoiceQuestionV1MaxSelectionAllowedMinValueError";
  }
}
